import { Link } from 'react-router-dom';

const articles = [
  {
    slug: '/what-is-mulebuy-spreadsheet',
    title: 'What Is Mulebuy Spreadsheet? Complete Guide 2026',
    excerpt: 'Discover everything about the Mulebuy Spreadsheet system — from basic definitions to advanced workflow strategies that help global buyers source smarter.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20with%20open%20laptop%20displaying%20colorful%20organized%20spreadsheet%20data%20alongside%20product%20catalog%20and%20coffee%2C%20bright%20clean%20daylight%2C%20professional%20workspace%2C%20learning%20and%20discovery%20concept%2C%20warm%20and%20inviting%20atmosphere&width=800&height=500&seq=blog-card-what-is-v2&orientation=landscape',
  },
  {
    slug: '/how-mulebuy-spreadsheet-works',
    title: 'How Mulebuy Spreadsheet Works Step by Step',
    excerpt: 'Walk through the complete 6-step workflow that transforms chaotic cross-border shopping into a streamlined, repeatable, and efficient sourcing process.',
    image: 'https://readdy.ai/api/search-image?query=Step%20by%20step%20workflow%20illustration%20on%20clean%20white%20wall%20with%20sticky%20notes%20and%20arrows%20connecting%20product%20discovery%20to%20delivery%2C%20organized%20process%20mapping%2C%20bright%20natural%20light%2C%20modern%20office%20environment%2C%20clarity%20and%20structure%20concept&width=800&height=500&seq=blog-card-how-works-v2&orientation=landscape',
  },
  {
    slug: '/best-mulebuy-spreadsheet-tools',
    title: 'Best Mulebuy Spreadsheet Tools Compared',
    excerpt: 'Compare Google Sheets, Excel, Airtable, and more — find the perfect spreadsheet platform to power your cross-border sourcing workflow.',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20tablets%20and%20laptops%20arranged%20in%20a%20row%20each%20displaying%20different%20spreadsheet%20interfaces%20and%20app%20icons%2C%20tech%20comparison%20concept%2C%20clean%20white%20desk%2C%20bright%20studio%20lighting%2C%20modern%20device%20showcase%20aesthetic&width=800&height=500&seq=blog-card-tools-v2&orientation=landscape',
  },
  {
    slug: '/is-mulebuy-spreadsheet-safe',
    title: 'Is Mulebuy Spreadsheet Safe? Full Risk Analysis',
    excerpt: 'An honest, transparent look at the safety considerations of Mulebuy Spreadsheet — covering data privacy, payment security, and scam prevention.',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20shield%20icon%20and%20checkmark%20on%20digital%20screen%20with%20soft%20green%20glow%2C%20cybersecurity%20and%20trust%20concept%2C%20dark%20ambient%20background%20with%20bokeh%20lights%2C%20reassuring%20professional%20atmosphere%2C%20safety%20and%20protection%20theme&width=800&height=500&seq=blog-card-safety-v2&orientation=landscape',
  },
  {
    slug: '/mulebuy-spreadsheet-vs-agents',
    title: 'Mulebuy Spreadsheet vs Traditional Shopping Agents',
    excerpt: 'Head-to-head comparison across cost, transparency, control, and speed. See why more shoppers are choosing the spreadsheet approach over agents.',
    image: 'https://readdy.ai/api/search-image?query=Split%20comparison%20visual%20with%20clean%20digital%20spreadsheet%20on%20left%20side%20and%20traditional%20paper%20documents%20on%20right%2C%20versus%20concept%2C%20warm%20neutral%20lighting%2C%20editorial%20style%2C%20decision%20making%20theme%2C%20balanced%20professional%20composition&width=800&height=500&seq=blog-card-vs-agents-v2&orientation=landscape',
  },
  {
    slug: '/beginner-guide-mulebuy-spreadsheet',
    title: 'Beginner Guide to Mulebuy Spreadsheet System',
    excerpt: 'Start from absolute zero — no experience required. This friendly guide walks beginners through everything needed for the first sourcing session.',
    image: 'https://readdy.ai/api/search-image?query=Welcoming%20desk%20with%20coffee%20cup%20notebook%20and%20open%20laptop%20showing%20simple%20starter%20template%2C%20warm%20morning%20sunlight%2C%20cozy%20home%20office%20vibe%2C%20beginner%20friendly%20atmosphere%2C%20encouraging%20and%20accessible%20learning%20environment&width=800&height=500&seq=blog-card-beginner-v2&orientation=landscape',
  },
  {
    slug: '/how-to-use-mulebuy-spreadsheet-efficiently',
    title: 'How to Use Mulebuy Spreadsheet Efficiently',
    excerpt: 'Speed-boosting techniques, keyboard shortcuts, and advanced tips that cut sourcing time by 70%+. Become a Mulebuy Spreadsheet power user.',
    image: 'https://readdy.ai/api/search-image?query=Fast%20paced%20productivity%20scene%20with%20hands%20typing%20rapidly%20on%20keyboard%2C%20dual%20monitors%20showing%20spreadsheet%20data%20and%20graphs%2C%20motion%20blur%20effect%2C%20energetic%20workspace%2C%20efficiency%20and%20speed%20concept%2C%20dynamic%20modern%20office&width=800&height=500&seq=blog-card-efficient-v2&orientation=landscape',
  },
  {
    slug: '/best-practices-mulebuy-spreadsheet',
    title: 'Best Practices for Mulebuy Spreadsheet Users',
    excerpt: 'Proven habits from experienced cross-border shoppers. Six simple practices that dramatically improve organization, accuracy, and sourcing outcomes.',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20color%20coded%20checklist%20and%20organized%20binders%20on%20clean%20desk%20with%20laptop%20showing%20highlighted%20spreadsheet%20rows%2C%20overhead%20flatlay%2C%20bright%20even%20lighting%2C%20productivity%20systems%20concept%2C%20professional%20organization%20aesthetic&width=800&height=500&seq=blog-card-practices-v2&orientation=landscape',
  },
  {
    slug: '/mulebuy-spreadsheet-pricing',
    title: 'Mulebuy Spreadsheet Pricing Explained',
    excerpt: 'Complete cost breakdown of cross-border shopping with Mulebuy Spreadsheet. See exactly where your money goes and how much you can save annually.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20flatlay%20of%20calculator%20receipts%20and%20laptop%20showing%20spreadsheet%20with%20price%20comparison%20highlighted%20in%20green%2C%20warm%20wooden%20surface%2C%20financial%20savings%20concept%2C%20soft%20natural%20lighting%2C%20transparent%20pricing%20theme&width=800&height=500&seq=blog-card-pricing-v2&orientation=landscape',
  },
];

export default function BlogSection() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="px-4 md:px-10">
        <div className="mb-12 md:mb-16">
          <span className="text-xs font-medium tracking-wider uppercase text-secondary-600 font-label">SEO Guides</span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.12] mt-3 tracking-tight">
            Mulebuy Spreadsheet
            <br />
            Complete Guide Series
          </h2>
          <p className="mt-4 text-base text-foreground-600 max-w-xl leading-relaxed">
            Explore our in-depth guide collection covering every aspect of the Mulebuy Spreadsheet system — from beginner basics to advanced optimization strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/80 transition-colors duration-300"
            >
              <div className="w-full h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-2 text-sm font-medium text-primary-500">
                  <span>Read Guide</span>
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}